export const rightSidebarConfig = {
  dimensions: {
    /** Always-docked icon rail width (collapsed state). */
    rail: 56,
    /** Default panel width when a tab is open; a route may override per rail. */
    open: 320,
  },
  durations: {
    expand: 200,
    contentVisibility: 100,
  },
};
